<template>
  <Layout></Layout>
</template>
<script>
import Layout from "../../../components/PRODUCTION/Avanzamento/GestioneLayout.vue";
export default {
  components: {
    Layout,
  },
  data() {
    return {};
  },
};
</script>